<template>
  <router-view />
</template>

<script>
export default {
  name: 'form-recipients-pages-container',
};
</script>
